
import { POST } from "../../APiHelper/API";

export const repopulateOtherNamesAPI = (team_id, onSuccess, onError) => {
    const data = {}
    POST(`/api/v1/leagues/team/${team_id}/repopulate_other_names`, data, onSuccess, onError)
}